<script setup lang="ts">
  import { Item } from '@borg/types';
  import { MpField, MpCheckbox } from '@borg/ui';
  import { toggleElementInArray } from '@borg/utils';

  const props = defineProps<{
    modelValue?: Item[];
    options: Item[];
    error?: string;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value?: Item[]): void;
  }>();

  function isSelected(option: Item) {
    if (props.modelValue) {
      return props.modelValue.some((o) => o.id === option.id);
    }

    return false;
  }

  function onClick(option: Item) {
    if (!props.modelValue) {
      emit('update:modelValue', [option]);
    } else {
      const nextModelValue = toggleElementInArray(
        props.modelValue,
        option,
        (o) => o.id === option.id,
      );

      emit('update:modelValue', nextModelValue);
    }
  }
</script>

<template>
  <MpField :error="error">
    <div class="field">
      <MpCheckbox
        v-for="option in options"
        :key="option.id"
        :model-value="isSelected(option)"
        :label="option.name"
        @click="onClick(option)"
      />
    </div>
  </MpField>
</template>

<style scoped>
  .field {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-20);
    margin-bottom: var(--mp-space-40);
  }
</style>
